import React, { useState } from 'react';
import HistoryItem from './HistoryItem';

const VoiceSidebar = ({
    topP,
    setTopP,
    temperature,
    setTemperature,
    setRepetitionPenalty,
    repetitionPenalty,
    sampleHistory,
    voices = [],
    selectedVoice,
    setSelectedVoice,
}) => {
    const [activeTab, setActiveTab] = useState('Settings');
    const [playingId, setPlayingId] = useState(null);

    // Voice list


    const handlePlay = (id) =>
        setPlayingId(playingId === id ? null : id);

    return (
        <div className="w-full h-[calc(100vh-3.5rem)] md:w-96 bg-white flex flex-col bg-gray-100">
            {/* Header Tabs */}
            <div className="flex items-center border-gray-200 text-sm space-x-4 p-3">
                {['Settings', 'History'].map((tab) => {
                    const active = activeTab === tab;
                    return (
                        <button
                            key={tab}
                            onClick={() => setActiveTab(tab)}
                            className={`relative pb-2 font-medium transition-colors ${active ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'
                                }`}
                        >
                            {tab}
                            {active && (
                                <span className="absolute -bottom-px left-1/2 -translate-x-1/2 h-0.5 w-10 bg-gray-900" />
                            )}
                        </button>
                    );
                })}
            </div>

            {/* Settings Content */}
            {activeTab === 'Settings' && (
                <div className="flex-1 p-6 flex flex-col gap-6">
                    {/* Voice Selector */}


                    <select
                        value={selectedVoice.id}
                        onChange={(e) =>
                            {

                                console.log("Selected voice ID:", e.target.value);

                                let topPValue = 0.9;
                                let temperatureValue = 0.6;
                                let repetitionPenaltyValue = 1.2;


                                for (const voice of voices) {
                                    console.log(`Voice ID: ${voice.id}, Name: ${voice.name}`);
                                    if (voice.id === e.target.value) {
                                        topPValue = voice.default_inference_parameters.topP || 0.9;
                                        temperatureValue = voice.default_inference_parameters.temperature || 0.6;
                                        repetitionPenaltyValue = voice.default_inference_parameters.repetitionPenalty || 1.2;
                                    }
                                }

                                console.log("Selected voice parameters - topP: %s, temperature: %s, repetitionPenalty: %s", topPValue, temperatureValue, repetitionPenaltyValue);
                                
                                setSelectedVoice(
                                voices.find((v) => v.id === e.target.value) ?? voices[0]
                            )

                            setTopP(topPValue || 0.9)
                            setTemperature(temperatureValue || 0.6)
                            setRepetitionPenalty(repetitionPenaltyValue || 1.2)

                        
                            }}
                        className="w-full border border-gray-300 rounded-md p-2 pr-4 text-sm focus:outline-none focus:ring-0 cursor-pointer"
                    >
                        {voices.map((v) => (
                            <option key={v.id} value={v.id}>
                                {v.name}
                            </option>
                        ))}
                    </select>


                    {/* topP */}
                    <div>
                        <div className="text-sm font-medium text-gray-900 mb-3">top P</div>
                        <input
                            type="range"
                            value={topP}
                            onChange={(e) => setTopP(parseFloat(e.target.value))}
                            min="0"
                            max="1"
                            step="0.005"
                            className="w-full accent-gray-900"
                        />
                        <div className="text-right text-xs text-gray-500 mt-1">
                            {topP.toFixed(3)}
                        </div>
                    </div>

                    {/* Temperature */}
                    <div>
                        <div className="text-sm font-medium text-gray-900 mb-3">
                            Temperature
                        </div>
                        <input
                            type="range"
                            value={temperature}
                            onChange={(e) =>
                                setTemperature(parseFloat(e.target.value))
                            }
                            min="0"
                            max="1"
                            step="0.005"
                            className="w-full accent-gray-900"
                        />
                        <div className="text-right text-xs text-gray-500 mt-1">
                            {temperature.toFixed(3)}
                        </div>
                    </div>

                    {/* Repetition Penalty */}
                    <div>
                        <div className="text-sm font-medium text-gray-900 mb-3">
                            Repetition Penalty
                        </div>
                        <input
                            type="range"
                            value={repetitionPenalty}
                            onChange={(e) =>
                                setRepetitionPenalty(parseFloat(e.target.value))
                            }
                            min="1"
                            max="3"
                            step="0.005"
                            className="w-full accent-gray-900"
                        />
                        <div className="text-right text-xs text-gray-500 mt-1">
                            {repetitionPenalty.toFixed(3)}
                        </div>
                    </div>
                </div>
            )}

{/* History Content */}
{activeTab === 'History' && (
  <div className="flex-1 flex flex-col min-h-0">
    {sampleHistory.length ? (
      /* scrollable list */
      <div className="flex-1 p-2 overflow-y-auto overflow-x-hidden space-y-1">
        {sampleHistory.map((item) => (
          <HistoryItem
            key={item.id}
            item={item}
            currentlyPlaying={playingId === item.id}
            onPlay={handlePlay}
          />
        ))}
      </div>
    ) : (
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="text-center text-gray-500">
          <div className="text-lg mb-2">No history yet</div>
          <div className="text-sm">Generated audio will appear here</div>
        </div>
      </div>
    )}
  </div>
)}


        </div>
    );
};

export default VoiceSidebar;
